import React, { ChangeEventHandler } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import MUITextField from '@mui/material/TextField';
import withController from '../lib/withController';

export { default as IconButton } from '@mui/material/IconButton';
export { default as InputAdornment } from '@mui/material/InputAdornment';

export type Variant = 'filled' | 'outlined' | 'standard';

const textFieldPropertyTypes = {
  variant: PropTypes.oneOf(['standard', 'filled', 'outlined'] as Variant[]),
  type: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
};

export type TextFieldProperties = Omit<InferProps<
  typeof textFieldPropertyTypes
>, 'onChange'> & {
  InputProps?: {
    endAdornment?: React.ReactNode;
  };
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

const TextField = React.forwardRef(
  (
    {
      variant,
      type,
      label,
      id,
      name,
      onChange,
      value,
      fullWidth,
      multiline,
      rows,
      disabled,
      ...rest
    } : TextFieldProperties,
    reference : React.ForwardedRef<HTMLDivElement>,
  ) => (
    <MUITextField
      {...rest}
      variant={variant ?? 'outlined'}
      type={type ?? 'text'}
      label={label}
      id={id}
      name={name}
      onChange={onChange}
      value={value ?? ''}
      fullWidth={fullWidth ?? false}
      multiline={multiline ?? false}
      rows={rows ?? undefined}
      disabled={disabled ?? false}
      ref={reference}
    />
  ),
);

export const TextFieldWithController = withController(TextField);

export default TextField;
